import { useEffect } from "react";
import { useAuth } from "./auth";

export const GetRoles = ({ setRole }) => {
  const auth = useAuth();
  useEffect(() => {
    const user = sessionStorage?.getItem("user")
      ? auth?.decoder(sessionStorage?.getItem("user"))
      : null;
    setRole(user?.data?.UserInfo?.role);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
